export default {
  loading: false,
  error: null,
  products: [],
  searchRefinements: [],
  filters: {
    keywords: [],
    pageSize: 10,
    sortKey: 'RELEVANCE',
    searchWithin: '',
    upc: '',
    shippingPostalCode: '',
    selected: [],
    single: {},
    pageNumber: 0
  },
  // pagination
  pagination: {
    total: 0,
    current_page: 0,
    last_page: 1,
    numberOfPages: 0
  },
  matchingProductCount: '100M+',
  productDetails: {},
  globalSearch: {},
  showDummyData: true
}